module.exports = __webpack_public_path__ + "static/img/empty.cb048aad.png";